import React, { useEffect, useState } from "react";
import PanelHead from "../../Panel/PanelHead";
import PanelBody from "../../Panel/PanelBody";
import { FormEditEmployee } from "./FormEditEmployee";
import { Helper } from "../../../tools/Helper";
import { api_Routes } from "../../../tools/api_Routes";
import { useParams } from "react-router-dom";
import { CircularProgress, LinearProgress } from "@mui/material";

export const PanelEditEmployee = () => {
    const { id } = useParams();
    const [isLoading, setIsLoading] = useState(true);
    const [permissions, setPermissions] = useState([]);
    const [managers, setManagers] = useState([]);
    const [roles, setRoles] = useState([]); // New state for roles
    const [data, setData] = useState({
        name: "",
        role: "",
        email: "",
        photo: null,
        active: 1,
        password: "",
        password_confirmation: "",
        permissions: [],
        manager_id: null,
    });

    const getData = async () => {
        try {
            const { result, response } = await Helper.Get({
                url: `${api_Routes.Employees.GetOne}${id}`,
            });

            if (response) {
                setData({
                    name: response.data.name || "",
                    role: response.data.role || "",
                    email: response.data.email || "",
                    photo: response.data.photo || "",
                    active: response.data.active ? 1 : 0,
                    password: "",
                    password_confirmation: "",
                    permissions: response.data.permissions || [],
                    manager_id: response.data.manager_id || null,
                });
            }
        } catch (error) {
            console.error("Error fetching details:", error);
        } finally {
            setIsLoading(false);
        }
    };

    // Fetch roles from backend
    const getRoles = async () => {
        try {
            const { response } = await Helper.Get({
                url: `${api_Routes.Roles.GetAll}?per_page=100`, // Fetch all roles
                hasToken: true,
            });
            if (response && response.data) {
                setRoles(response.data.data || response.data); // Adjust based on your API response structure
            }
        } catch (error) {
            console.error("Error fetching roles:", error);
        }
    };

    // Fetch managers
    const getManagers = async () => {
        try {
            const { result, response } = await Helper.Get({
                url: `${api_Routes.Employees.GetManagers}`,
            });
            if (response) {
                setManagers(response.data);
            }
        } catch (error) {
            console.error("Error fetching managers:", error);
        }
    };

    useEffect(() => {
        getData();
        getRoles(); // Fetch roles
        getManagers();
    }, []);

    return (
        <div>
            <PanelHead
                title={
                    isLoading ? (
                        <div className="flex items-center gap-4">
                            Edit Employee <CircularProgress size={24} />
                        </div>
                    ) : (
                        <div className="flex items-center justify-between w-full gap-4">
                            <div>Edit Employee: {data?.name}</div>
                        </div>
                    )
                }
            />
            <PanelBody
                content={
                    isLoading ? (
                        <LinearProgress />
                    ) : (
                        <FormEditEmployee
                            data={data}
                            managers={managers}
                            roles={roles} // Pass roles to form
                            setData={setData}
                        />
                    )
                }
            />
        </div>
    );
};